import React, { useRef } from 'react'
import { Button, Menu } from '@CommonComponents/buttons'
import { toast } from '@CommonComponents/toast'
import { client } from '@Utils'
import { codeOrderManagement as endpoints } from '@URLS'
import { useStateValue } from '@State'
import { history } from './App'

export const OrderFilters = ({ coursenum, pageNum }) => {
  const menuContainer = useRef(null)
  const [currentState, dispatch] = useStateValue()

  const closeFilters = () => {
    // Use the shared trigger to retain exit motion and focus return.
    menuContainer.current
      .querySelector('[data-menu-trigger][aria-expanded="true"]')
      ?.click()
  }

  const handleChange = (name, value) => {
    let filters = {
      ...currentState.filters,
      [name]: value,
    }
    dispatch({
      type: 'updateFilters',
      payload: filters,
    })
  }

  const clearFilters = () => {
    dispatch({
      type: 'updateFilters',
      payload: {
        createDateLowerBound: '',
        createDateUpperBound: '',
        emailFilter: '',
        statusFilter: '',
        institutionFilter: '',
        courseIdentifierFilter: '',
      },
    })
    history.push(
      `/account/admin_coupons.management/${coursenum}/?page_num=${pageNum}`
    )
  }

  const applyFilters = async () => {
    closeFilters()
    let params = new URLSearchParams()
    let filterKeys = Object.keys(currentState.filters)
    for (let i = 0; i < filterKeys.length; i++) {
      let key = filterKeys[i]
      if (currentState.filters[key] !== '') {
        params.append(key, currentState.filters[key])
      }
    }

    try {
      let resp = await client.post(
        endpoints.pageOrders({
          pageNum: pageNum,
          filterString: params.toString(),
        })
      )
      dispatch({
        type: 'updateOrderCount',
        payload: resp.data.totalOrderCount,
      })
      dispatch({
        type: 'updateOrders',
        payload: resp.data.orders,
      })
    } catch (err) {
      console.error(err)
      toast.error(`There was an error while applying the filters. ${err}`)
    }
  }

  return (
    <div ref={menuContainer} className="d-flex flex-row-reverse cursor-auto">
      <Menu
        label="Filter"
        surfaceLabel="Order filters"
        mode="panel"
        align="end"
        className="me-btn me-btn-secondary me-btn-sm me-btn-menu-trigger"
      >
        <div className="p-3">
          <div className="text-right">
            <Button
              className="me-btn me-btn-secondary me-btn-sm"
              onClick={closeFilters}
              icon="fa-regular fa-times"
            >
              Close
            </Button>
          </div>
          <div className="d-flex">
            <label className="ml-3 w-100">
              Create date between:
              <div>
                <input
                  type="date"
                  name="createDateLowerBound"
                  value={currentState.filters.createDateLowerBound}
                  className="form-control pointer"
                  onChange={evt =>
                    handleChange(evt.target.name, evt.target.value)
                  }
                />
              </div>
              <div>
                and
                <input
                  type="date"
                  name="createDateUpperBound"
                  value={currentState.filters.createDateUpperBound}
                  className="form-control pointer"
                  onChange={evt =>
                    handleChange(evt.target.name, evt.target.value)
                  }
                />
              </div>
            </label>
          </div>
          <div className="p-3 w-100">
            <label className="mt-3 w-100">
              Email address contains:
              <div className="w-100">
                <input
                  type="text"
                  className="w-100"
                  value={currentState.filters.emailFilter}
                  name="emailFilter"
                  onChange={evt =>
                    handleChange(evt.target.name, evt.target.value)
                  }
                />
              </div>
            </label>
          </div>
          <form className="mt-3 p-3 w-100">
            <label htmlFor="invoice-status-select">Invoice Status</label>
            <select
              id="invoice-status-select"
              className="form-control w-100 pointer"
              value={currentState.filters.statusFilter}
              name="statusFilter"
              onChange={evt => handleChange(evt.target.name, evt.target.value)}
            >
              <option value="">Select a status</option>
              <option value="Outstanding">Outstanding</option>
              <option value="Paid">Paid</option>
              <option value="Voided">Voided</option>
            </select>
          </form>
          <div className="p-3 w-100">
            <label className="mt-3 w-100">
              Institution Contains:
              <div className="w-100">
                <input
                  type="text"
                  className="w-100"
                  value={currentState.filters.institutionFilter}
                  name="institutionFilter"
                  onChange={evt =>
                    handleChange(evt.target.name, evt.target.value)
                  }
                />
              </div>
            </label>
          </div>
          <div className="p-3 w-100">
            <label className="mt-3 w-100">
              Course Identifier Contains:
              <div className="w-100">
                <input
                  type="text"
                  className="w-100"
                  value={currentState.filters.courseIdentifierFilter}
                  name="courseIdentifierFilter"
                  onChange={evt =>
                    handleChange(evt.target.name, evt.target.value)
                  }
                />
              </div>
            </label>
          </div>
          <div className="p-3 w-100">
            <label className="mt-3 w-100">
              Coupon Code (exact match):
              <div className="w-100">
                <input
                  type="text"
                  className="w-100"
                  value={currentState.filters.couponCode}
                  name="couponCodeFilter"
                  onChange={evt =>
                    handleChange(evt.target.name, evt.target.value)
                  }
                />
              </div>
            </label>
          </div>
          <div className="m-3">
            <Button
              className="me-btn me-btn-primary mr-3"
              onClick={applyFilters}
            >
              Apply Filters
            </Button>
            <Button className="me-btn me-btn-secondary" onClick={clearFilters}>
              Clear Filters
            </Button>
          </div>
        </div>
      </Menu>
    </div>
  )
}
